import React from "react";
import AdIntelligence from "../../components/AdIntelligence";

const AdIntelligencePage = () => {
  return <AdIntelligence />;
};

export default AdIntelligencePage;
